<template>
    <div v-if="is_Admin" class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Устройства</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить устройство</a>
        </div>
    </div>

    <div class="table-controls">
        <div class="search-control">
            <input @keyup.delete="onDeleteSearchByNumberPharmacy()"
                   @keyup.enter="onSearch()"
                   type="text" v-model="search"
                   class="search-control__input form-control"
                   placeholder="Адрес или номер аптеки">
            <button v-if="!hasSearch" @click="onSearch()" class="search-control__input-btn reset-btn">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
                </svg>
            </button>
            <button v-else @click="clearSearch()" class="search-control__input-btn reset-btn">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 4.00004L4 14M3.99996 4L13.9999 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </button>
        </div>
        <div class="selects">
            <v-select class="select"
                label="Тип устройства"
                v-model="deviceType"
                :items="deviceTypes"
                @update:modelValue="onChangeDeviceType"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>

            <v-select class="select"
                label="Статус"
                v-model="statusDevice"
                :items="statuses"
                @update:modelValue="onChangeStatusDevice"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>
        <div class="float-right">
            <a class="btn brn-primary-fit" @click="showExportModal">Экспорт</a>
        </div>
    </div>

    <table class="service-table table align-middle">
        <thead>
            <tr>
                <th style="min-width: 95px;" scope="col" v-for="(elem, index) in thead" :key="index">
                    <div class="th-inner sortable asc">
                        {{ elem }}
                        <div v-if="['Клиент', 'Организация', 'Номер аптеки', 'Адрес'].includes(elem)" class="dropdown">
                            <button class="dropdown-toggle" @click="toggleDropdown(index)"></button>
                            <div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(row, rowIndex) in tbody" :key="rowIndex">
                <td v-bind:class = "(row.tbody.status === 1) ? 'color-green' : 'color-red'">{{ row.tbody.status_title }}</td>
                <td>{{ row.tbody.client_name }}</td>
                <td>{{ row.tbody.org_name }}</td>
                <td>{{ row.tbody.pharmacy_number }}</td>
                <td>{{ row.tbody.address }}</td>
                <td>{{ row.tbody.type }} {{ row.tbody.item }}</td>
                <td>
                    <div class="d-flex">
                        <button v-if="is_Admin" @click="actionClick('editItem', row)" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
                        <a :href="route_history + '/' + row.id" class="table-action table-action_status_history m-auto align-middle" title="История изменения статусов"></a>
                        <button v-if="is_Admin" @click="actionClick('deleteItem', row)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <Transition name="fade">
        <div>
            <ExportModal
                v-if="exportModal"
                :filters="filter"
                :file-name="'Устройства'"
                :route-export="route_download_data_xlsx"
            />
        </div>
    </Transition>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import ChangePage from "../../../helpers/ChangePage";
import PaginationElement from "../../../elements/PaginationElement";
import Device from "../../../models/Device";
import ExportModal from "../../../modals/ExportModal.vue";
import { mapState, mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DeviceComponent',
    components: {
        PaginationElement,
        ExportModal
    },
    props: {
        route_create_page: String,
        route_edit: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        route_history: String,
        route_get_names_devices_types: String,
        route_get_statuses: String,
        route_download_data_xlsx: String,
        route_clients: String,
        route_brands: String,
        route_organizations: String,
        route_regions: String,
        current_page: {
            type: Number,
            default: 1
        },
        is_admin: String
    },
    data: function () {
        return {
            device: new Device({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),

            status: null,
            statuses: [],
            statusStore: null,
            selected_status: null,
            statusDevice: null,
            selected_status_device: null,

            deviceType: null,
            deviceTypes: [],
            selected_device_type: null,

            client: null,
            clients: [],

            brand: null,
            brands: [],

            organization: null,
            organizations: [],

            region: null,
            regions: [],

            thead: [
                'Статус', 'Клиент', 'Организация', 'Номер аптеки', 'Адрес', 'Тип и порядковый №', 'Действия'
            ],

            tbody: [],

            hasSearch: false,
            search: null,
            searchNumberPharmacy: '',

            count: 1,
            limit: 30,
            page: 1,

            dropdownVisible: Array(7).fill(false),

            currentSortColumn: '',
            currentSortOrder: '',

            columnMap: {
                'Клиент': 'client_name',
                'Организация': 'org_name',
                'Номер аптеки': 'pharmacy_number',
                'Адрес': 'address'
            },

            is_Admin: this.is_admin === 'true'
        }
    },
    computed: {
        ...mapState('logs', ['exportModal']),
        filter() {
			return [
                {
					type: 'select',
					name: 'Статус',
                    key: 'status',
					model: this.status,
					options: this.statuses,
                    title: 'name'
				},
                {
					type: 'select',
					name: 'Клиент',
                    key: 'client',
					model: this.client,
					options: this.clients,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Бренд',
                    key: 'brand',
					model: this.brand,
					options: this.brands,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Организация',
                    key: 'organization',
					model: this.organization,
					options: this.organizations,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Регион',
                    key: 'region',
					model: this.region,
					options: this.regions,
                    title: 'name'
				},
                {
					type: 'select',
					name: 'Тип устройства',
                    key: 'device_type',
					model: this.deviceType,
					options: this.deviceTypes,
                    title: 'name'
				}
			]
		},
    },
    methods: {
        ...mapMutations('logs', ['showExportModal']),
        deleteDevice: function (params) {
            if(params.hasOwnProperty('id'))
            {
                let id = params.id;
                this.device.delete(id).then(this.loadTable);
            }
            else
            {
                console.log('Error: delete_item_undefined');
            }
        },
        editDevice: function (params) {
            location.href = this.route_edit + params.id;
        },
        loadTable: async function () {
            let response = await this.device.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selected_device_type,
                this.selected_status_device,
                this.currentSortColumn,
                this.currentSortOrder
            );
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
        onSearch: async function () {
            this.hasSearch = true;
            this.page = 1;
            await this.loadTable()
        },
        clearSearch: async function() {
            this.search = '';
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearchByNumberPharmacy: async function () {
            if (this.searchNumberPharmacy.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        actionClick: function (emit, item) {
            if(emit == 'deleteItem') {
                let conf = confirm('Вы уверены что хотите удалить устройство?');
                if(!conf) {
                    return;
                }
                if (conf) {
                    this.deleteDevice(item)
                }
            }

            if(emit == 'editItem') {
                this.editDevice(item)
            }

        },
        onChangeDeviceType: async function (type_id) {
            this.selected_device_type = type_id;
            this.loadTable();
        },
        onChangeStatusDevice: async function (status_id) {
            this.selected_status_device = status_id;
            this.loadTable();
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types, {
                params: { limit: 9999 }
            });
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        getStatuses: async function () {
            let data = await axios.get(this.route_get_statuses, {
                params: { limit: 9999 }
            });
            this.statuses = data.data;

            for (const key in this.statuses) {
                this.statuses[key] = {
                    id: Number(key) + 1,
                    name: this.statuses[key]
                }
            }
        },
        getClients: async function () {
            let data = await axios.get(this.route_clients, {
                params: { limit: 9999 }
            });
            this.clients = data.data.items;
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands, {
                params: { limit: 9999 }
            });
            this.brands = data.data.items;
        },
        getOrganizations: async function () {
            let data = await axios.get(this.route_organizations, {
                params: { limit: 9999 }
            });
            this.organizations = data.data.items;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_regions, {
                params: { limit: 9999 }
            });
            this.regions = data.data.items;
        },
        toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },
        closeDropdown(event) {
            const clickOutside = event.target.className !== 'dropdown-item';
            const dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            };
        },
        sortBy(order, column) {
            this.currentSortColumn = this.columnMap[column]
            this.currentSortOrder = order
            this.loadTable()
        },
    },
    watch: {
        search: {
            handler(newValue) {
                if (newValue === '') {
                    this.search = null;
                    this.hasSearch = false;
                }
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown);
        this.loadTable();
        this.getStatuses();
        this.getDevicesTypesName();
        this.getClients();
        this.getBrands();
        this.getOrganizations();
        this.getRegions();
    }
}
</script>

<style scoped>
    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-toggle {
        background: none;
        border: none;
        cursor: pointer;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        display: none;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }

    .dropdown .show {
        display: block;
        padding: 0px;
    }

    .table-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 20px;
    }
    .selects {
        min-width: 500px;
        display: flex;
        gap: 16px;
    }
    .select {
        width: 250px;
    }
    .float-right {
        margin-left: auto;
    }
</style>
